<template>
  <v-container v-if="!!prediction">
    <toolbar mode="prediction" :item="prediction" />
    <v-card flat>
      <prediction
        :applications="applications"
        :models="methods"
        :datasets="datasets"
        :prediction="prediction"
        :techniques="techniques"
        @submitted="onSubmit"
      ></prediction>
    </v-card>
  </v-container>
</template>

<script>
import toolbar from "@/components/toolbar"
import prediction from "@/components/Forms/Prediction"
import Applications from "@/api/applications"
import Predictions from "@/api/predictions"
import Methods from "@/api/methods"
import Datasets from "@/api/datasets"
import Techniques from "@/api/techniques"
export default {
  name: "EditPrediction",
  components: {
    toolbar,
    prediction
  },
  data() {
    return {
      prediction: null,
      applications: [],
      methods: [],
      datasets: [],
      techniques: []
    }
  },
  created() {
    Predictions.retrieve(this.$route.params.uuid).then(response => this.prediction = response.data)
    Methods.list().then(response => this.methods = response.data)
    Applications.list().then(response => this.applications = response.data)
    Datasets.list().then(response => this.datasets = response.data.results.filter(d => d.status == 'SUCCESS'))
    Techniques.list().then(response => this.techniques = response.data)
  },
  methods: {
    onSubmit(prediction) {
      Predictions.update(
        this.$route.params.uuid, {
          name: prediction.name,
          application: prediction.application,
          methods: prediction.methods,
          dataset: prediction.dataset,
          config: prediction.config,
          owner: this.user.id
        }
      ).then(_ => {
        this.$store.commit("removeProgress", this.prediction.uuid)
        this.$router.push({ name: "predictionList" })
      })
    }
  }
}
</script>